import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm10 3a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2zm-4 4a1 1 0 1 1 0 2H8a1 1 0 1 1 0-2z",
      clipRule: "evenodd"
    }
  )
);
var SvgFileFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FileFilled_default = SvgFileFilled;

export { FileFilled_default as default };
